module.exports = __webpack_public_path__ + "img/1014844182.21913b11.jpg";